export default "__VITE_ASSET__p5jrq_oI__"